import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaTint, FaTachometerAlt, FaFileInvoiceDollar, FaPlusCircle, FaBuilding } from 'react-icons/fa';
import LogoutButton from './LogoutButton';
import '../style/admin.css';

function Sidebar() {
  const location = useLocation();

  return (
    <aside className="admin-sidebar">
      <div className="sidebar-brand">
        <div className="sidebar-logo">
          <FaTint />
        </div>
        <div className="sidebar-brand-text">
          <h2>LR Water Billing</h2>
          <span>Admin Console</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        <div className="nav-section-label">Core Navigation</div>
        <Link to="/admin" className={`nav-item ${location.pathname === '/admin' ? 'active' : ''}`}>
          <FaTachometerAlt className="nav-icon" />
          <span>Dashboard Overview</span>
        </Link>
        <Link to="/adminreport" className={`nav-item ${location.pathname === '/adminreport' ? 'active' : ''}`}>
          <FaFileInvoiceDollar className="nav-icon" />
          <span>Billing Reports</span>
        </Link>
        {/* <Link to="/property" className={`nav-item ${location.pathname === '/property' ? 'active' : ''}`}>
          <FaBuilding className="nav-icon" />
          <span>Properties</span>
        </Link> */}
        <Link to="/home" className={`nav-item ${location.pathname === '/home' ? 'active' : ''}`}>
          <FaPlusCircle className="nav-icon" />
          <span>Collect Reading</span>
        </Link>
      </nav>

      <div className="sidebar-footer">
        <LogoutButton style={{ width: "100%", justifyContent: "center" }} />
      </div>
    </aside>
  );
}

export default Sidebar;
